import '../css/Info.css';
import Footer from './Footer';
import Header from './Header';
import React from "react";
import { useNavigate, Outlet, useLocation } from "react-router-dom";

function Copyright() {
    const navigate = useNavigate();
    const location = useLocation(); // 현재 경로 감지

    return (
        <div className="Info-container">
            <Header />
            <div className="info-container">
                {/* 왼쪽 사이드 버튼 */}
                <div className="info-left-container">
                    <div
                        className={`info-contents-container ${location.pathname === "/copyright/model" ? "active" : ""}`}
                    >
                        <button onClick={() => navigate("/copyright/model")}>
                            사용 모델
                        </button>
                    </div>
                </div>

                {/* 오른쪽 영역 (하위 라우트 표시) */}
                <div className="info-detail-container">
                    <Outlet />
                </div>
            </div>
            <Footer />
        </div>
    );
}

export default Copyright;
